export default __webpack_public_path__ + "static/media/AGENCYR.a28a90a7.TTF";